import type { ClerkProviderProps } from '@clerk/react'

// The supported Clerk appearance contract: exactly what ClerkProvider accepts.
// Deriving it from ClerkProviderProps keeps this module honest across Clerk
// upgrades. This build ships no prebuilt dark theme export, so the shell maps
// Clerk's typed variables onto the command-center palette instead.
export type ClerkAppearance = NonNullable<ClerkProviderProps['appearance']>

// Every value below comes from the canonical command-center palette in
// globals.css (@theme). Do not introduce hex values that are not defined there.
const COMMAND_CENTER_THEME = {
  variables: {
    colorPrimary: '#d8341f',
    colorBackground: '#191817',
    colorForeground: '#fdfaf3',
    colorInput: '#0e0d0c',
    colorInputForeground: '#fdfaf3',
    colorMuted: '#191817',
    colorMutedForeground: '#8d8477', // ink-meta (RAL-103 contrast correction — see globals.css)
    colorNeutral: '#fdfaf3',
    colorBorder: '#3a352f',
    colorDanger: '#f4715a',
    colorSuccess: '#8fd89b',
    colorWarning: '#e6bb5e',
    colorShadow: '#0c0b0a',
    borderRadius: '0px',
    fontFamily: "'Archivo', ui-sans-serif, system-ui, sans-serif",
    fontFamilyButtons: "'Archivo', ui-sans-serif, system-ui, sans-serif"
  }
}

// Applied once at ClerkProvider so every mounted Clerk surface inherits it;
// the explicit userProfile entry also covers the full-screen profile the
// UserButton opens.
export const CLERK_APPEARANCE: ClerkAppearance = {
  ...COMMAND_CENTER_THEME,
  userProfile: COMMAND_CENTER_THEME
}
